import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { IPayResponse, pay } from '@r1-frontend/api-domru/api-loyalty/v1/program/pay';

import { selectCardPaySum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { IPaymentResult, setPaymentResult } from '~/src/features/payments-abn/store/actionCreators';
import { TState } from '~/src/store';
import { getLoyaltyInfo } from '~/src/store/actions/loyalty';
import selectProviderId from '~/src/store/selectors/selectProviderId';

/**
 * Выполняет оплату бонусами
 */
export const useSendBonusesPayment = () => {
    const dispatch = useDispatch();
    const {
        payment: {
            paymentData: { isUseBonuses, bonusesValue },
            result,
        },
        providerId,
    } = useSelector((state: TState) => ({
        auth: state.auth,
        payment: state.payment,
        providerId: selectProviderId(state),
    }), shallowEqual);

    const cardPaymentSum = useSelector(selectCardPaySum);

    const isOnlyBonusesPay = !cardPaymentSum && isUseBonuses && !!bonusesValue;

    const sendBonusesPayment = async() => {
        if (!bonusesValue) {
            return;
        }

        const resp = await doRequest.apiLoyalty<IPayResponse>(
            pay(providerId, { bonusValue: bonusesValue }),
        );

        const respData: IPaymentResult = {
            ...result,
            isBonusesSuccess: resp.isSuccess,
            isOpenPopup: isOnlyBonusesPay,
        };
        dispatch(getLoyaltyInfo());
        dispatch(setPaymentResult(respData));
    };

    return {
        isOnlyBonusesPay,
        sendBonusesPayment,
    };
};
